import {
  PRODUCT_CARD_PARAMS_ERROR,
  PRODUCT_CARD_TYPE,
} from '@/utils/logger/instance/productCardBusinessLogger';

//处理传入的宽高
export const formatStyle = (style: string | number | undefined): string => {
  if (!style) {
    return '';
  }
  if (typeof style === 'number') {
    return `${style}px`;
  }

  if (typeof style === 'string') {
    // 如果已经是有效的 CSS 宽度格式，直接返回
    if (style.endsWith('px') || style.endsWith('%') || style === 'auto') {
      return style;
    }

    // 尝试将字符串转换为数字
    const numstyle = parseFloat(style);
    if (!isNaN(numstyle)) {
      return `${numstyle}px`;
    }
  }

  // 如果无法处理，返回默认值或抛出错误
  throw new Error('Invalid width format');
};

//处理标签样式
export const imgTipsStyle = (position: string) => {
  let style = {};
  switch (position) {
    case 'topLeft':
      style = { top: 0, left: 0 };
      break;
    case 'topRight':
      style = { top: 0, right: 0 };
      break;
    case 'bottomLeft':
      style = { bottom: 0, left: 0 };
      break;
    case 'bottomRight':
      style = { bottom: 0, right: 0 };
      break;
  }
  return style;
};

//判断如果划线价小于等于优惠价格则不展示
export const comparePrice = (originalPrice: string, realPrice: string): boolean => {
  return Number(realPrice) < Number(originalPrice);
};

//商卡曝光参数处理
export const getExptag = (type: string, params: any, ExpType: string) => {
  if (params && params[ExpType]) {
    const { event_id, config, json_param, event_param } = params[ExpType];
    switch (type) {
      case 'exptag':
        return `exp|${event_id}`;
      case 'config':
        return JSON.stringify(config);
      case 'json-param':
        return JSON.stringify(json_param);
      case 'event-param':
        return JSON.stringify(event_param);
      default:
        return '';
    }
  } else {
    return '';
  }
};

export const getSpmExpData = (params: any, ExpType: string, isSpm: boolean) => {
  if (params && params[ExpType]) {
    const { spm, biz_type, event_id, json_param, config } = params[ExpType];
    if (isSpm) {
      return {
        'data-exp': JSON.stringify({
          spm,
          biz_type,
          event_id,
          json_param,
        }),
        'data-exptag-config': config && JSON.stringify(config),
      };
    } else {
      return {
        exptag: getExptag('exptag', params, ExpType),
        'data-exptag-config': getExptag('config', params, ExpType),
        'data-exptag-json-param': getExptag('json-param', params, ExpType),
        'data-exptag-event-param': getExptag('event-param', params, ExpType),
      };
    }
  }
};

//获取商品促销标签的文案；promotionType的含义：优惠券: 2  ,单品促销: 1, 总价促销: 10  ,时效标签: 3
export const getPromotionObj = (promotions: any) => {
  const promotionObj = {
    couponInfo: '-100',
    single_promotion: '-100',
    amount_promotion: '-100',
    time_label: '-100',
    brand_name: '-100',
  };
  const single_promotion: string[] = [];
  const amount_promotion: string[] = [];
  const couponInfo: string[] = [];
  const time_label: string[] = [];
  if (promotions) {
    promotions.map((promotion: any) => {
      promotion = expandShowStyle(promotion);
      //需要屏蔽掉老版本的秒杀倒计时营销标签
      if (promotion.srType === 3) {
        return;
      }
      switch (promotion.promotionType) {
        case 1:
          single_promotion.push(`${promotion.text}${promotion?.endTime || ''}`);
          break;
        case 10:
          amount_promotion.push(`${promotion.text}${promotion?.endTime || ''}`);
          break;
        case 2:
          couponInfo.push(`${promotion.text}${promotion?.endTime || ''}`);
          break;
        case 3:
          time_label.push(`${promotion.text}${promotion?.endTime || ''}`);
          break;
      }
      //商卡品牌文案埋点参数
      if (promotion.type === 7) {
        promotionObj.brand_name = promotion.text || '-100';
      }
    });

    promotionObj.couponInfo = couponInfo.length > 0 ? couponInfo.join(';') : '-100';
    promotionObj.single_promotion =
      single_promotion.length > 0 ? single_promotion.join(';') : '-100';
    promotionObj.amount_promotion =
      amount_promotion.length > 0 ? amount_promotion.join(';') : '-100';
    promotionObj.time_label = time_label.length > 0 ? time_label.join(';') : '-100';
    return promotionObj;
  }
  return promotionObj;
};

const expandShowStyle = (obj: any) => {
  const showStyleObj = obj?.showStyle ? JSON.parse(obj?.showStyle) : {};
  return { ...obj, ...showStyleObj };
};

//处理商卡入参错误上报sgm
export const paramsLoggerError = (productData: any, type: any) => {
  if (!productData) {
    return {
      params_error: PRODUCT_CARD_PARAMS_ERROR.N_PD,
      message: {
        type,
        msg: 'productData is null',
      },
    };
  }
  const { from, skuId, skuImgKeyParams, skuImg, realPrice, currency } = productData;
  if (skuId === undefined || skuId === null) {
    return {
      params_error: PRODUCT_CARD_PARAMS_ERROR.N_SKU,
      message: {
        from,
        msg: 'Missing SkuId',
      },
    };
  }
  if (!(skuImgKeyParams ? skuImgKeyParams?.imgUrlKey : skuImg)) {
    return {
      params_error: PRODUCT_CARD_PARAMS_ERROR.N_IMG,
      message: {
        from,
        type,
        msg: 'Missing main product image',
        mainSkuId: skuId,
      },
    };
  }

  if (!realPrice && (type === PRODUCT_CARD_TYPE.TYPE_2 || type === PRODUCT_CARD_TYPE.TYPE_3)) {
    return {
      params_error: PRODUCT_CARD_PARAMS_ERROR.N_R,
      message: {
        from,
        type,
        msg: 'Missing realPrice',
        mainSkuId: skuId,
      },
    };
  }
  if (realPrice && !currency) {
    return {
      params_error: PRODUCT_CARD_PARAMS_ERROR.N_C,
      message: {
        from,
        type,
        msg: 'Missing currency',
        mainSkuId: skuId,
      },
    };
  }
  return;
};
